<div class="container-fluid">
    <h3>Listado de usuarios</h3>
    <h4 >Realice una búsqueda de usuario con ingresando los parámetros correspondientes en los campos.
        <br><strong>Para seleccionar un usuario presiona sobre su nombre.</strong>
    </h4>
    <app-security-user-list (selecttab)="changeMenuModule($event)"></app-security-user-list>

  <button
    type="button"
    [routerLink]="['/modulo-seguridad/', 'seguridad', 'creacion-perfil']"
    (click)="changeMenuModule('creacion-perfil')"
    class="mt-5 btn round-button">
    Crear Usuario
  </button>
  </div>
